import styled from 'styled-components';

import { Button } from '../../../components/ui/Button';

const PaginationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  margin-top: var(--space-lg);
`;

const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-md);
  flex-wrap: wrap;
`;

const PageInfo = styled.span`
  color: var(--text-muted);
  font-size: var(--font-size-sm);
`;

const PageControls = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-sm);
`;

interface CompliancePaginationProps {
  page: number;
  perPage: number;
  total: number;
  onPageChange: (page: number) => void;
}

export const CompliancePagination = ({
  page,
  perPage,
  total,
  onPageChange,
}: CompliancePaginationProps) => {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const startIndex = total === 0 ? 0 : (page - 1) * perPage + 1;
  const endIndex = Math.min(page * perPage, total);

  return (
    <PaginationContainer aria-label="Paginación de cumplimiento">
      <PaginationRow>
        <PageInfo>
          {total === 0
            ? 'Sin resultados'
            : `Mostrando ${startIndex}-${endIndex} de ${total}`}
        </PageInfo>
        <PageInfo>
          Página {page} de {totalPages}
        </PageInfo>
      </PaginationRow>
      <PaginationRow>
        <PageControls>
          <Button
            variant="secondary"
            size="sm"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
            aria-label="Página anterior"
          >
            Anterior
          </Button>
          <Button
            variant="secondary"
            size="sm"
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
            aria-label="Página siguiente"
          >
            Siguiente
          </Button>
        </PageControls>
      </PaginationRow>
    </PaginationContainer>
  );
};

CompliancePagination.displayName = 'CompliancePagination';
